export * from './post-bereich.component';
export * from './post-bereich.component.module';